import { render, staticRenderFns } from "./carRetail.vue?vue&type=template&id=6ad4fa7c&"
import script from "./carRetail.vue?vue&type=script&lang=js&"
export * from "./carRetail.vue?vue&type=script&lang=js&"
import style0 from "./carRetail.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports